import { useQuery } from "react-query";
import { useRequest } from "../contexts/request";

// Public product list for a streamer's toko (tipper POV).
// ponytail: GET /store/products/public/{username} contract not finalized yet;
// wired so the grid renders once the endpoint lands.
const useTokoProducts = ({ username, keyword = "", page = 1, limit = 12 }, opts = {}) => {
  const { get } = useRequest();
  return useQuery(
    ["toko-products", username, keyword, page],
    async () => {
      const qs = new URLSearchParams(
        Object.entries({ keyword, page, limit }).filter(([, v]) => v !== undefined && v !== "")
      ).toString();
      const { json } = await get(`store/products/public/${username}?${qs}`);
      return json.data; // { page, products: [] }
    },
    {
      enabled: Boolean(username),
      keepPreviousData: true,
      staleTime: 10000,
      retry: false,
      ...opts,
    }
  );
};

export { useTokoProducts };
